import React, {Component} from 'react'

import IpadNavigation from 'Navigation/IpadNavigation'
import MoreSupplierInvoices from 'More/views/MoreSupplierInvoicesView/containers/Smartphones'

export default class MoreSupplierInvoicesView extends Component {
  render () {
    return (
      <IpadNavigation {...this.props} onlyLeftSide>
        <MoreSupplierInvoices {...this.props} notRightIcon />
      </IpadNavigation>
    )
  }
}
